import { track } from '@eventbrite/datalayer-library';
import isUndefined from 'lodash/isUndefined';

import { ISocialLogInApiResponseProps } from '../api/social';

import {
    HEAP_EVENT_NAME_WEB_SIGNIN_LOGIN_SUCCESSFUL,
    LOGIN_METHOD_APPLE,
    LOGIN_METHOD_EVENTBRITE,
    LOGIN_METHOD_FACEBOOK,
    LOGIN_METHOD_GOOGLE,
} from '../constants/analytics';

import { capitalize } from './utils';

export const trackLoginSuccessInHeap = ({
    loginMethod,
}: {
    loginMethod?: string;
}) => {
    track({
        eventName: HEAP_EVENT_NAME_WEB_SIGNIN_LOGIN_SUCCESSFUL,
        eventData: {
            loginMethod: !isUndefined(loginMethod)
                ? capitalize(loginMethod)
                : LOGIN_METHOD_EVENTBRITE,
        },
    });
};

export const trackFBLoginSuccessInHeap = ({
    response,
}: {
    response: ISocialLogInApiResponseProps;
}) => {
    if (response.newUser) {
        trackLoginSuccessInHeap({
            loginMethod: LOGIN_METHOD_FACEBOOK,
        });
    } else {
    }
};

export const trackAppleLoginSuccessInHeap = ({
    response,
}: {
    response: any;
}) => {
    if (response.newUser ?? response['new_user']) {
        trackLoginSuccessInHeap({
            loginMethod: LOGIN_METHOD_APPLE,
        });
    } else {
        // One step login
    }
};

export const trackGoogleLoginSuccess = ({ response }: { response: any }) => {
    if (response['new_user']) {
        trackLoginSuccessInHeap({
            loginMethod: LOGIN_METHOD_GOOGLE,
        });
    } else {
        // One step login
    }
};
